module.exports = __webpack_public_path__ + "img/yellow_eye.e6ff4275.svg";